module.exports = __webpack_public_path__ + "img/title-dver-2-m.5f54eedd.png";